"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    caption: {
      wordBreak: 'break-word',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      //Specificity hack to avoid use of important and override aem-page > p margins
      '&$caption': {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(0)
      },
      '& strong': {
        marginRight: theme.spacing(2)
      }
    }
  };
});
var ImageCaption = function ImageCaption(_ref) {
  var captionTitle = _ref.captionTitle,
    caption = _ref.caption;
  var classesDefault = useStyles();
  var title = captionTitle ? "<strong>".concat(captionTitle, "</strong>") : '';
  var captionText = caption ? "<span>".concat(caption, "</span>") : '';
  return __jsx(_core.Typography, {
    className: (0, _clsx.default)(classesDefault.caption, 'cmp-image__title'),
    dangerouslySetInnerHTML: {
      __html: "".concat(title).concat(captionText)
    }
  });
};
var _default = ImageCaption;
exports.default = _default;